import React, { memo, useCallback, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Text, Icon } from '@Sage/hoi-poi-ui';
import SingleNode from 'components/TreeNavigatorNew/SingleNode';
import { getLiteral } from 'utils/getLiteral';
import { canManageMarketingCampaigns } from './utils/marketingCampaignPermissions';

const NAV_ITEMS = [
    {
        id: 'email-campaigns',
        icon: 'emailSendOutline',
        labelKey: 'label_emails',
        path: '/campaigns/marketing',
        match: (path) => {
            if (path.startsWith('/campaigns/marketing/templates')) return false;
            if (path.startsWith('/campaigns/marketing/settings')) return false;
            return path.startsWith('/campaigns/marketing');
        },
    },
    // {
    //     id: 'email-templates',
    //     icon: 'emailStar',
    //     labelKey: 'label_email_templates',
    //     path: '/campaigns/marketing/templates',
    //     match: (path) => path.startsWith('/campaigns/marketing/templates'),
    // },
    // {
    //     id: 'segments',
    //     icon: 'contactList',
    //     labelKey: 'label_segments',
    //     path: '/campaigns/marketing/initial-setup',
    //     match: (path) => path.startsWith('/campaigns/marketing/initial-setup'),
    // },
    {
        id: 'settings',
        icon: 'settings',
        labelKey: 'label_settings',
        path: '/campaigns/marketing/settings',
        match: (path) => path.startsWith('/campaigns/marketing/settings'),
        requiresManage: true,
    },
];

const MATCH_PRIORITY_ITEMS = [...NAV_ITEMS].sort((a, b) => b.path.length - a.path.length);

const ContentNavigator = memo(() => {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const canManage = useSelector(canManageMarketingCampaigns);

    const activeNodeId = useMemo(
        () => MATCH_PRIORITY_ITEMS.find((item) => item.match(pathname))?.id ?? null,
        [pathname],
    );

    const handleClick = useCallback(
        (path) => () => {
            if (pathname === path) return;
            navigate(path);
        },
        [navigate, pathname],
    );

    return (
        <div id="campaigns-marketing__navigator">
            <Text className="campaigns-marketing__navigator__title" type="subtitle" medium>
                {getLiteral('label_your_email_campaigns')}
            </Text>

            <div className="campaigns-marketing__navigator__nodes"></div>
            {NAV_ITEMS.filter((item) => !item.requiresManage || canManage).map((item) => (
                <SingleNode
                    key={item.id}
                    icon={<Icon name={item.icon} />}
                    text={getLiteral(item.labelKey)}
                    isSelected={item.id === activeNodeId}
                    onClick={handleClick(item.path)}
                />
            ))}
        </div>
    );
});

export default ContentNavigator;
